<!-- @format -->

@if (addToCartButtonText()) {
  <div
    id="pdp-add-to-cart"
    class="hmf-display-flex hmf-justify-content-between hmf-my-xs hmf-my-m-s hmf-px-s hmf-px-lg-0">
    <button
      hmf-button
      [text]="buttonTextWithOptionalPrice()"
      variant="primary"
      id="pdp-add-to-cart-button"
      class="hmf-flex-grow"
      type="submit"
		[disabled]="
			addToCartButtonText().addToCartButtonDisabled ||
			(addToCartButtonText().addToCartButtonText === atcButtonTexts.noStoreSelected &&
				!storeSelectionReady())
		"
		(click)="
			addToCartButtonClicked(
				addToCartButtonText().addToCartButtonText,
				addToCartButtonText().buttonAction
			)
		"></button>
  </div>
}
